import { render, staticRenderFns } from "./MelosDevices.vue?vue&type=template&id=0bb44ab2&"
import script from "./MelosDevices.vue?vue&type=script&lang=ts&"
export * from "./MelosDevices.vue?vue&type=script&lang=ts&"
import style0 from "./MelosDevices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports